import React from 'react';
import LoadingBar from './src/components/LoadingBar';
import Clarity from '@microsoft/clarity';

// Microsoft Clarity (grabaciones/heatmaps) — solo en producción
// para no contaminar las métricas con sesiones de desarrollo.
export const onClientEntry = () => {
  if (process.env.NODE_ENV === 'production') {
    Clarity.init('vmk5tc848h');
  }
};

export const wrapRootElement = ({ element }) => {
  return (
    <>
      <LoadingBar />
      {element}
    </>
  );
};

export const onPreRouteUpdate = () => {
  if (typeof window !== 'undefined') {
    // Gatsby restaura la posición con window.scrollTo(x, y), que obedece al
    // scroll-behavior del elemento; con el `smooth` del reset, cada navegación
    // se animaría desde donde estuviera el usuario. Se apaga durante la
    // transición y se devuelve al CSS al terminar.
    document.documentElement.style.scrollBehavior = 'auto';
    const event = new CustomEvent('loadingStart');
    window.dispatchEvent(event);
  }
};

export const onRouteUpdate = () => {
  if (typeof window !== 'undefined') {
    // Cadena vacía, no 'smooth': quita el estilo inline y devuelve la decisión
    // al CSS, que es donde vive el @media (prefers-reduced-motion).
    requestAnimationFrame(() => {
      document.documentElement.style.scrollBehavior = '';
    });

    // Sincronizar document.title con el <title data-gatsby-head> del Head API.
    // Gatsby actualiza el Head de forma asíncrona tras onRouteUpdate,
    // por eso usamos MutationObserver para detectar cuándo aparece el nuevo título.
    const syncTitle = () => {
      const titleEl = document.querySelector('title[data-gatsby-head]');
      if (titleEl && titleEl.textContent && document.title !== titleEl.textContent) {
        document.title = titleEl.textContent;
        return true;
      }
      return false;
    };

    // Intentar inmediatamente (funciona en hard refresh)
    if (!syncTitle()) {
      // Si no se pudo sincronizar aún, observar cambios en <head>
      const head = document.querySelector('head');
      if (head) {
        const observer = new MutationObserver(() => {
          if (syncTitle()) {
            observer.disconnect();
          }
        });
        observer.observe(head, { childList: true, subtree: true });
        // Seguro: desconectar después de 5 segundos como máximo
        setTimeout(() => observer.disconnect(), 5000);
      }
    }

    const event = new CustomEvent('loadingComplete');
    window.dispatchEvent(event);
  }
};

// El scroll lo gestiona Gatsby (gatsby-react-router-scroll) con su
// comportamiento por defecto, que ya hace lo correcto: arriba en una
// navegación nueva, posición guardada al volver con Atrás/Adelante, y salto al
// elemento del hash cuando la URL trae uno (#contenido, #cafe-y-agua, #como…).
// NO reintroducir un shouldUpdateScroll que devuelva false: apagaba las tres.
